"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOriDocument = createOriDocument;
var _cache = _interopRequireDefault(require("@emotion/cache"));
var _v14PagesRouter = require("@mui/material-nextjs/v14-pagesRouter");
var _shared = require("@ori-appshell/shared");
var _environment = require("@ori/environment");
var _zodUtils = require("@ori/zod-utils");
var _document = _interopRequireDefault(require("next/document"));
var _DocumentBody = _interopRequireDefault(require("./components/DocumentBody"));
var _logger = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('OriDocument');
const resolvePublicPathDefault = ({
  asPath = '/',
  req
}) => {
  if (!asPath.startsWith('/internal')) {
    return asPath;
  }

  // IMPORTANT: this will only resolve pathname without query params!
  const publicRequestPathFromMiddleware = req?.headers['ori-public-request-path'];
  return String(publicRequestPathFromMiddleware ?? asPath);
};
function createOriDocument({
  appName,
  emotionCacheKey,
  resolvePublicPath = resolvePublicPathDefault
}) {
  return class OriDocument extends _document.default {
    // TODO: This could be also executed on client (while page trasitioning) and we do only serverside code here.
    // Modify it so it works on both client and server
    static async getInitialProps(context) {
      // Server only modules must be imported here
      // eslint-disable-next-line node/file-extension-in-import -- extension needs to be used or Node.js wont resolve
      const {
        getDocumentPropsCached
      } = await import(/* webpackIgnore: true */'./server/getDocumentPropsCached.js');
      // eslint-disable-next-line node/file-extension-in-import -- extension needs to be used or Node.js wont resolve it
      const {
        getInitialDocumentProps
      } = await import(/* webpackIgnore: true */'./internals/server/getInitialDocumentProps.js');
      const {
        query
      } = context;
      // console.log(`${new Date().toTimeString()}: Starting OriDocument.getInitialProps`);

      let documentProps;
      const initialProps = await _document.default.getInitialProps(context);

      // Create props and attach initial
      let props = {
        ...initialProps,
        ...(await (0, _v14PagesRouter.documentGetInitialProps)(context, {
          // TODO (ZMA) Remove `emotionCacheKey` and make a major release. `appName` should be enough for the cache key.
          emotionCache: (0, _cache.default)({
            key: emotionCacheKey ?? appName
          })
        })),
        clientApplicationInsightsConfig: global.oriAppInsightsSettings
      };
      const tenant = (0, _zodUtils.validateTenant)(query.tenant) ?? _environment.DEFAULT_TENANT;
      const language = (0, _zodUtils.validateLanguage)(query.language) ?? _shared.DEFAULT_LANGUAGE;
      try {
        documentProps = await getDocumentPropsCached({
          tenant,
          language,
          sourceAppName: appName
        });
      } catch (error) {
        // This can happen mostly during build (Missing environment variables), or when the APIs called are failing.
        // In both cases, we want to return at least inital props so error page can be built.

        logger.error(new Error('Failed to execute getCommonPropsCached', {
          cause: error
        }));
        return {
          ...props,
          documentBuiltAt: new Date().toString()
        };
      }
      const {
        servicesUrls,
        appshellConfig: {
          ENVIRONMENT: environment
        },
        languagesForMetadata
      } = documentProps;
      props = {
        ...props,
        servicesUrls,
        environment,
        languagesForMetadata: languagesForMetadata ?? [],
        hostname: servicesUrls.online.baseUrl,
        publicPathname: resolvePublicPath(context),
        tenant
      };

      // Get initial document props
      try {
        props = {
          ...props,
          language,
          ...(await getInitialDocumentProps({
            tenant,
            staticApiUrl: servicesUrls.staticApi.baseUrl
          }))
        };
      } catch (error) {
        logger.error(new Error('Failed to get getInitialDocumentProps', {
          cause: error
        }));
      }
      return {
        ...props,
        documentBuiltAt: new Date().toString()
      };
    }
    render() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentBody.default, {
        ...this.props
      });
    }
  };
}
//# sourceMappingURL=OriDocument.js.map